import { FC } from 'react';

import { Varmekilde } from '../../../../../utils/registerEnums';
import { EnumRadioButton } from '../components/enumRadioButton';
import { EnumRadioGroup } from '../components/enumRadioGroup';

interface Props {
  onChange: (value: Varmekilde) => void;
  value?: Varmekilde;
}

export const VarmekildeRadio: FC<Props> = ({ onChange, value }) => {
  const i18nPrefix = 'register.tekniskUtstyr.oppvarmingVarmepumpe.varmeKilde';
  return (
    <EnumRadioGroup
      labelKey={`${i18nPrefix}.label`}
      helperTextKey={`${i18nPrefix}.information`}
      value={value ?? Varmekilde.Ukjent}
      onChange={(val) => onChange(val as Varmekilde)}
    >
      <EnumRadioButton i18nPrefix={`${i18nPrefix}.option`} value={Varmekilde.LuftFraDetFri} />
      <EnumRadioButton i18nPrefix={`${i18nPrefix}.option`} value={Varmekilde.LuftFraVentilasjonsanlegg} />
      <EnumRadioButton i18nPrefix={`${i18nPrefix}.option`} value={Varmekilde.Vann} />
      <EnumRadioButton i18nPrefix={`${i18nPrefix}.option`} value={Varmekilde.JordGrunnFjell} />
      <EnumRadioButton i18nPrefix={`${i18nPrefix}.option`} value={Varmekilde.Ukjent} />
    </EnumRadioGroup>
  );
};
